export default "__VITE_ASSET__DnVgl$44__"